import { gql, useMutation } from '@apollo/client'

export const UPDATE_LABEL_TEMPLATE = gql`
  mutation($id: String!, $template: String!) {
    updateLabelTemplate(id: $id, template: $template) {
      id
    }
  }
`

export const useUpdateLabelTemplate = () => {
  const [mutate, { data, loading, error }] = useMutation(UPDATE_LABEL_TEMPLATE, {
    update(cache) {
      cache.modify({
        fields: {
          getLabelTemplates() {}
        }
      })
    }
  })

  return { mutate, data, loading, error }
}
